// extracted by mini-css-extract-plugin
module.exports = {"Comment":"EventComments_Comment__3D8Pd","Right":"EventComments_Right__UDDIp","Left":"EventComments_Left__PNvPd"};